import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerEnum, registerMutation } from '@adornis/baseql/metadata/register.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';

import { authenticatedMiddleware } from '../../permissions/middlewares/authenticatedMiddleware.js';
import { resolveDownloadEmployeeFormTemplates } from './server/resolveDownloadEmployeeFormTemplates.js';

export enum DownloadEmployeeFormTemplates {
  STRAFVERFAHREN = 'STRAFVERFAHREN',
  ANTRAGFUEHRUNGSZEUGNISS = 'ANTRAGFUEHRUNGSZEUGNISS',
  PERSONLABOGEN = 'PERSONLABOGEN',
  INFEKTIONSSCHUTZ = 'INFEKTIONSSCHUTZ',
  GESUNDHEITSZEUGNIS = 'GESUNDHEITSZEUGNIS',
}

registerEnum({ enum: DownloadEmployeeFormTemplates, name: 'DownloadEmployeeFormTemplates' });

export const downloadEmployeeFormTemplates = registerMutation({
  operationName: 'downloadEmployeeFormTemplates',
  type: () => AdornisFile,
  params: [
    { type: () => DownloadEmployeeFormTemplates, name: 'template' },
    { type: () => ID, name: 'userID' },
  ],
  middlewares: [authenticatedMiddleware],
  resolve: resolveDownloadEmployeeFormTemplates,
});
